/* eslint-disable */
export const doubleArrowLeftIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M13.32 18.3933L7.5116 11.6168L13.32 4.84033" stroke="currentColor" stroke-width="1.4521" stroke-linecap="round" stroke-linejoin="round"/><path d="M17.1923 18.3933L11.3839 11.6168L17.1923 4.84033" stroke="currentColor" stroke-width="1.4521" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'double-arrow-left' as const,
};
